import React from "react";
import { projects } from "../data";
import { ExternalLink } from "lucide-react";
import "./PageStyles.css";

const ProjectsPage = () => (
  <div className="page">
    <header className="page-header">
      <h1 className="section-title">Featured Projects</h1>
      <p className="page-lead">Selected work showcasing my expertise in full-stack development across various domains.</p>
    </header>
    <section className="section section-dark">
      <div className="container">
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card-enhanced">
              <div className="project-image-container">
                <img src={project.image} alt={project.name} className="project-image" />
                <div className="project-overlay">
                  {project.url && (
                    <a 
                      href={project.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="project-link-btn"
                    >
                      <ExternalLink size={20} />
                      <span>Visit Project</span>
                    </a>
                  )}
                </div>
                {project.category && (
                  <span className="project-category-badge">{project.category}</span>
                )}
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.name}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  <span className="tech-label">Technologies:</span>
                  <div className="tech-badges">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-badge">{tech}</span>
                    ))}
                  </div>
                </div>
                <div className="project-features">
                  <span className="features-label">Key Features:</span>
                  <ul className="features-list">
                    {project.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default ProjectsPage;

